import React from "react";
import IndividualDeliverable from "./individualDeliverable";
import { Action } from "../../../constants/Common";

const AddDeliverableModule = (props) => {
  return (
    <div
      className="editDeliverable_height"
      style={{ height: "auto", maxHeight: "900px" }}
    >
      {props?.deliverable &&
        props?.deliverable?.map((dL, index) => {
          return (
            <IndividualDeliverable
              key={index}
              action={Action.CREATE}
              eachDeliverable={dL}
              eachDeliverableIndex={index}
            />
          );
        })}
    </div>
  );
};

export default AddDeliverableModule;
